module.exports = __webpack_public_path__ + "img/infoPetroleo.14d873d8.jpg";